module.exports = __webpack_public_path__ + "static/img/two.8dc5ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/11/two.png
// module id = c0Sx
// module chunks = 1